<template>
	<div id="app">
		<div class="loadingmb" v-if="Loading">
		<div class="loadEffect">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
		</div>
		</div>
    <router-view/>
	</div>
</template>

<script>
export default {
  name: 'App',
  data() {
  	return {

  	}
  },
  computed:{
		Loading() {
			return this.$store.getters.Loading
		}
  },
  methods:{
	isMobile(){
	    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		// localStorage.setItem('isiphone',flag)
		// localStorage.setItem('ismobile',flag?1:0)
	    return flag;
	  },
	  //网址生成
	  getnewurl() {
	    let url = window.location.href
	    let urlnew = ''
	    if (url.indexOf("?") != -1) {
		let index1 = url.split("?")[0];
		let index2 = url.split("?")[1];
	  	// encodeURIComponent()
	  	// decodeURIComponent()
	  	let parmse = index2
	      urlnew ="?" + parmse
	    }
	    return urlnew
	  }
  },
  created() {
	    // console.log(window.location)
	  //判断是否为手机端
  	if(this.isMobile()){
		//环境切换
		if (process.env.NODE_ENV == 'development') {
			window.location.href = "http://172.16.5.159:8081/#/" + this.getnewurl()
		} else if (process.env.NODE_ENV == 'production') {
		  window.location.href = "http://" + window.location.hostname + ":10597/#/" + this.getnewurl()
		}
	}
  },
  beforeDestroy() {

  },
  mounted() {
  }
}
</script>

<style>
	@import url("styles/App.css");
	@import url("./styles/loading/loading.css");
</style>

<style>
	#app{

	}
	.loadingmb{
		height: 100vh;
		width: 100vw;
		position: fixed;
		z-index:665;
		background: rgba(76,74,72,0.2);
	}
</style>


// WEBPACK FOOTER //
// src/App.vue